import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "11",
  height: "21",
  fill: "none",
  viewBox: "0 0 11 21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M10.148 11.75h-2.93v8.75H3.314v-8.75H.108V8.156h3.204V5.383C3.313 2.258 5.187.5 8.038.5c1.367 0 2.813.273 2.813.273V3.86H9.25c-1.562 0-2.031.938-2.031 1.954v2.343h3.476z"
    }, null, -1)
  ])))
}
export default { render: render }